module.exports = __webpack_public_path__ + "static/family-in-masks-158994b14ca3a03077cd455720ca1ef4.png";